import { UserSetting } from './model/user.model';
import { Injectable } from '@angular/core';

@Injectable()
export class LocaleService {
  public static userSettings: UserSetting;
  private static _locale: string;
  public static set locale(value: string) {
    this._locale = value;
  }
  public static get locale(): string {
    return this._locale || LocaleService.getLocale();
  }
  public static getLocale(): string {
    if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
      return undefined;
    }
    let browserLang: any = window.navigator['languages'] ? window.navigator['languages'][0] : null;
    browserLang =
      browserLang ||
      window.navigator.language ||
      (window.navigator as any)['browserLanguage'] ||
      (window.navigator as any)['userLanguage'];
    if (browserLang.indexOf('-') !== -1) {
      browserLang = browserLang.split('-')[0];
    }
    if (browserLang.indexOf('_') !== -1) {
      browserLang = browserLang.split('_')[0];
    }
    return browserLang; // 'ar-AE';
  }
  public getLocale(): string {
    return LocaleService.getLocale();
  }
}
